import React from 'react';
import * as Icon from 'react-feather';
import { all_routes } from '../routes/all_routes';
const routes = all_routes;
export const adminSidebar = [
  {
    tittle: 'Dashboard',
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: 'Statistics',
        hasSubRoute: false,
        showSubRoute: false,
        route: '/',
        icon: <Icon.Grid className="react-feather-icon" />,
      },
    ],
  },
  {
    tittle: 'Support',
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: 'Contact Requests',
        hasSubRoute: false,
        showSubRoute: false,
        route: routes.contactRequests,
        icon: <Icon.Mail className="react-feather-icon" />,
      },
    ],
  },
 /*  {
    tittle: 'Admin',
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: 'Kullanıcıları Yönet',
        hasSubRoute: false,
        showSubRoute: false,
        route: '/admin/list-users',
        icon: <Icon.User className="react-feather-icon" />,
      },
      // {
      //   menuValue: 'Yasaklı Alanlar',
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   route: '/drivers/manage-restricted-locations',
      //   icon: <Icon.MapPin className="react-feather-icon" />,
      // },
      // {
      //   menuValue: 'Yolculuk Tipleri',
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   route: '/drivers/journey-types',
      //   icon: <Icon.ShoppingCart className="react-feather-icon" />,
      // },
      // {
      //   menuValue: 'Sürücüleri Yönet',
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   route: '/drivers/list-drivers',
      //   icon: <Icon.User className="react-feather-icon" />,
      // },
      // {
      //   menuValue: 'Arabalar',
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   route: '/drivers/list-cars',
      //   icon: <Icon.Truck className="react-feather-icon" />,
      // },
    ],
  }, */
  {
    tittle: 'CRM',
    showAsTab: false,
    separateRoute: false,
    menu: [
      // {
      //   menuValue: 'Müşterileri Yönet',
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   route: '/customers/list-customers',
      //   icon: <Icon.Briefcase className="react-feather-icon" />,
      // },
      {
        menuValue: 'Partners',
        hasSubRoute: false,
        showSubRoute: false,
        route: '/partners',
        icon: <Icon.FileText className="react-feather-icon" />,
      },
      {
        menuValue: 'Projects',
        hasSubRoute: false,
        showSubRoute: false,
        route: '/projects',
        icon: <Icon.FileText className="react-feather-icon" />,
      },
      {
        menuValue: 'Leads',
        hasSubRoute: false,
        showSubRoute: false,
        route: '/leads',
        icon: <Icon.FileText className="react-feather-icon" />,
      },
      {
        menuValue: 'Proposals',
        hasSubRoute: false,
        showSubRoute: false,
        route: '/proposals',
        icon: <Icon.FileText className="react-feather-icon" />,
      },
    ],
  },
 
  
  
];
